import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date (or ISO string) as a value suitable for an
 * <input type="datetime-local"> — i.e. local time in `YYYY-MM-DDTHH:MM`.
 * Using `Date#toISOString().slice(0, 16)` here is a bug because that returns
 * UTC, not local — it shifts the value by the user's timezone offset.
 */
export function toLocalDateTimeInputValue(input: Date | string | number): string {
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
